import { Agent } from "https";

import fetch from "node-fetch";
import pLimit, { Limit } from "p-limit";

import { delay } from "../../../../../../Common/AsyncUtils";
import { NotFoundWebError } from "../../../../Commons/HttpServer/AttributeRouting/NotFoundWebError";

import { createWebPackDevServerWorker } from "./WebpackDevServerWorker/WebpackDevServerWorkerFactory";

export class EngineDevServer {
    private readonly port: number;
    private readonly engineDirectory: string;
    private readonly startParallelLimit: Limit;
    private readonly theme: undefined | string;
    private started = false;
    private readonly buildDebugOnly: boolean;
    private readonly httpsAgent = new Agent({ rejectUnauthorized: false, keepAlive: true });

    public constructor(port: number, engineDirectory: string, buildDebugOnly: boolean, theme: undefined | string) {
        this.port = port;
        this.engineDirectory = engineDirectory;
        this.startParallelLimit = pLimit(1);
        this.buildDebugOnly = buildDebugOnly;
        this.theme = theme;
    }

    public async start(): Promise<void> {
        return this.startParallelLimit(async () => {
            if (this.started) {
                return;
            }
            const commonOptions = {
                resourcesPath: "dist",
                serving: "true",
                theme: this.theme,
            };
            const options = this.buildDebugOnly
                ? {
                      ...commonOptions,
                      development: "true",
                      production: "false",
                      testing: "false",
                  }
                : commonOptions;
            await createWebPackDevServerWorker(this.engineDirectory, "webpack.config.js", this.port, options);

            this.started = true;
        });
    }

    public async getFileAsStream(filename: string): Promise<NodeJS.ReadableStream> {
        while (!this.started) {
            await delay(500);
        }
        const response = await fetch(`https://localhost:${this.port}/static/${filename}`, {
            method: "GET",
            agent: this.httpsAgent,
        });
        if (response.status === 404) {
            throw new NotFoundWebError(`Cannot find ${filename} at runtime dev server runner at ${this.port}`);
        }
        return response.body;
    }
}
